"use strict";

var _interopRequireDefault = require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

var _web = require("@/api/web");

var _customPage = _interopRequireDefault(require("@/components/customPage"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    customPage: _customPage.default
  },
  data: function data() {
    return {
      tableData: [],
      total: 0
    };
  },
  methods: {
    // 列表项删除
    removeItem: function removeItem(id, level) {
      var _this = this;

      this.$confirm('您确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _web.deleteCategory)({
          cate_id: level ? id : id.split('-')[1],
          cate_level: level ? 1 : 2
        }).then(function (res) {
          _this.getList();
        }).catch(function () {});
      });
    },
    // 更改显示隐藏状态
    changeStatus: function changeStatus(id, level) {
      var _this2 = this;

      (0, _web.editCategoryStatus)({
        cate_id: level ? id : id.split('-')[1],
        cate_level: level ? 1 : 2
      }).then(function (res) {
        _this2.getList();
      });
    },
    // 更改排序
    changeSort: function changeSort(id, level, val) {
      var _this3 = this;

      (0, _web.sortCategory)({
        cate_id: level ? id : id.split('-')[1],
        cate_level: level ? 1 : 2,
        cate_sort: val
      }).then(function (res) {
        _this3.getList();
      });
    },
    // 获取列表
    getList: function getList() {
      var _this4 = this;

      var _this$$refs$customPag = this.$refs.customPage,
          page = _this$$refs$customPag.page,
          pageSize = _this$$refs$customPag.pageSize;
      (0, _web.getCategortList)({
        page: page,
        pageSize: pageSize
      }).then(function (res) {
        // console.log(res);
        _this4.tableData = res.data || [];
        _this4.total = res.total;
      });
    }
  },
  mounted: function mounted() {
    this.getList();
  }
};
exports.default = _default;